import { takeLatest } from 'redux-saga/effects';
import encounterOrdersWorkerSaga from './encounterOrdersWorkerSaga';
import { FETCH_ENCOUNTER_ORDERS_REQUEST } from '../../redux/modules/encounterOrders/encounterOrders-actions';

export default function* encounterOrdersWatcherSaga() {
    yield takeLatest(FETCH_ENCOUNTER_ORDERS_REQUEST, encounterOrdersWorkerSaga);
}
